// extracted by mini-css-extract-plugin
module.exports = {"image":"util-ContentfulImage__image--tnXgq","loaded":"util-ContentfulImage__loaded--gkRMs","error":"util-ContentfulImage__error--1l24z"};